import React from 'react';

export const ShutterCenterOpeningPostRight = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 103.24 59.3"
      width="111"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h92.25v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.4V.59A.71.71 0 015.49 0h92.25a.69.69 0 01.77.59V51.4c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM96.97 1.18H6.29v49.63h90.68z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h92.25v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.4V.59A.71.71 0 015.49 0h92.25a.69.69 0 01.77.59V51.4c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM96.97 1.18H6.29v49.63h90.68z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h83.43v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.63c-.42 0-.77-.26-.77-.58V3.94c0-.32.35-.58.78-.58h83.39c.42 0 .77.26.77.58V48c0 .32-.35.58-.77.58H9.89zm82.67-44.1H10.67v42.93h81.89z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 52h101.78c.4 0 .73-.25.73-.55a.66.66 0 00-.73-.56H.73a.65.65 0 00-.73.56c0 .25.29.55.73.55z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 84">
        <g data-name="Group 486">
          <path
            data-name="Rectangle 169"
            fill="#233762"
            d="M96.34 2.25L69.2 8.55l-.12 49.99 27.26-6.8V2.25z"
          />
          <path
            data-name="Path 2326"
            d="M68.71 8l28.11-6.48v50.73l-28.23 7zm27.15-5L69.68 9.06l-.11 48.73 26.29-6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 487">
          <path
            data-name="Rectangle 170"
            fill="#233762"
            d="M93.47 8.13l-21.54 5.06-.01 3.58 21.55-5.07V8.13z"
          />
          <path
            data-name="Path 2327"
            d="M71.67 12.92l22.05-5.16V12l-22.05 5.2zm21.55-4.4l-21 4.92v2.94l21-4.95z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 488">
          <path
            data-name="Rectangle 171"
            fill="#233762"
            d="M93.47 11.7l-21.55 5.07-.01 3.59 21.56-5.12V11.7z"
          />
          <path
            data-name="Path 2328"
            d="M71.67 16.5l22.05-5.19v4.2l-22.06 5.22zm21.55-4.43L72.17 17v3l21.05-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 489">
          <path
            data-name="Rectangle 172"
            fill="#233762"
            d="M93.47 15.26l-21.56 5.1-.01 3.58 21.57-5.14v-3.54z"
          />
          <path
            data-name="Path 2329"
            d="M71.66 20.08l22.06-5.22v4.21l-22.07 5.26zm21.56-4.45l-21.06 5v2.95l21.06-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 490">
          <path
            data-name="Rectangle 173"
            fill="#233762"
            d="M93.47 18.84L71.9 23.97v3.59l21.57-5.16v-3.56z"
          />
          <path
            data-name="Path 2330"
            d="M71.65 23.71l22.07-5.26v4.21L71.64 28zm21.57-4.5l-21.06 5v2.94l21.07-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 491">
          <path
            data-name="Rectangle 174"
            fill="#233762"
            d="M93.47 22.4L71.9 27.56l-.01 3.59 21.58-5.19V22.4z"
          />
          <path
            data-name="Path 2331"
            d="M71.64 27.29L93.71 22v4.21l-22.08 5.33zm21.58-4.51l-21.07 5v2.94l21.08-5.06z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 492">
          <path
            data-name="Rectangle 175"
            fill="#233762"
            d="M93.47 25.96l-21.58 5.19-.01 3.59 21.59-5.21v-3.57z"
          />
          <path
            data-name="Path 2332"
            d="M71.64 30.89l22.07-5.31v4.21l-22.08 5.34zm21.57-4.54l-21.07 5.07v2.94l21.08-5.09z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 493">
          <path
            data-name="Rectangle 176"
            fill="#233762"
            d="M93.47 29.53l-21.59 5.21-.01 3.6 21.6-5.24v-3.57z"
          />
          <path
            data-name="Path 2333"
            d="M71.63 34.48l22.08-5.33v4.21l-22.09 5.37zm21.58-4.57L72.13 35v3l21.08-5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 494">
          <path
            data-name="Rectangle 177"
            fill="#233762"
            d="M93.47 33.1l-21.6 5.24v3.6l21.6-5.27V33.1z"
          />
          <path
            data-name="Path 2334"
            d="M71.62 38.08l22.09-5.37v4.22l-22.1 5.4zm21.59-4.6l-21.08 5.13v2.94l21.09-5.15z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 495">
          <path
            data-name="Rectangle 178"
            fill="#233762"
            d="M93.47 36.67l-21.6 5.27-.01 3.6 21.61-5.3v-3.57z"
          />
          <path
            data-name="Path 2335"
            d="M71.61 41.68l22.1-5.4v4.22L71.6 45.93zM93.21 37l-21.09 5.2v3L93.21 40z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 496">
          <path
            data-name="Rectangle 179"
            fill="#233762"
            d="M93.47 40.26l-21.61 5.3-.01 3.61 21.62-5.33v-3.58z"
          />
          <path
            data-name="Path 2336"
            d="M71.6 45.3l22.11-5.42v4.22L71.6 49.56zm21.61-4.65l-21.1 5.18v3l21.11-5.2z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 497">
          <path
            data-name="Rectangle 180"
            fill="#233762"
            d="M93.47 43.84l-21.62 5.33-.01 3.6 21.63-5.36v-3.57z"
          />
          <path
            data-name="Path 2337"
            d="M71.6 48.9l22.11-5.45v4.23l-22.12 5.48zm21.61-4.68L72.1 49.43v3l21.11-5.23z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 181"
          fill="#fff"
          d="M83.35 10.52l-1.41.33-.05 39.43 1.41-.35.05-39.41z"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M39.06 8.28l27.79-6.03v49.49l-27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338"
            d="M67.34 52.25l-28.78 7V7.75l28.78-6.23zm-27.78 5.54l26.8-6.55V3l-26.8 5.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M42.06 12.94L64.1 8.09v3.56l-22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M64.36 11.92l-22.55 5v-4.26l22.55-4.95zm-22.07 4.23l21.53-4.77V8.46L42.29 13.2z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M42.06 16.55l22.04-4.9v3.57l-22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M64.36 15.48l-22.55 5.06v-4.27l22.55-5zm-22.07 4.28L63.85 15v-3l-21.56 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M42.06 20.16l22.04-4.94v3.58l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M64.36 19.05l-22.55 5.11v-4.28l22.55-5zm-22.07 4.34l21.53-4.87V15.6l-21.53 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M42.06 23.8l22.04-4.98v3.57l-22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342"
            d="M64.36 22.65L41.81 27.8v-4.27l22.55-5.1zM42.29 27l21.53-4.9v-2.91l-21.53 4.88z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M42.06 27.41l22.04-5.02v3.57l-22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343"
            d="M64.36 26.22l-22.55 5.19v-4.27L64.36 22zm-22.07 4.41l21.53-4.94v-2.92l-21.53 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M42.06 31.02l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M64.36 29.79L41.81 35v-4.25l22.55-5.18zm-22.07 4.46l21.53-5v-2.91l-21.53 4.95z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M42.06 34.63l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M64.36 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22.07 4.51l21.53-5v-3L42.29 34.9z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M42.06 38.24l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M64.36 36.92l-22.55 5.33V38l22.55-5.3zm-22.07 4.55l21.53-5.08v-2.92l-21.53 5.04z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M42.06 41.86l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M64.36 40.49l-22.55 5.37v-4.27l22.55-5.31zm-22.07 4.59L63.85 40v-3l-21.56 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M42.06 45.49l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M64.36 44.08L41.81 49.5v-4.27l22.55-5.36zm-22.07 4.64l21.53-5.17v-2.92l-21.53 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M42.06 49.11l22.04-5.29v3.57l-22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349"
            d="M64.36 47.65l-22.55 5.46v-4.27l22.55-5.41zm-22.07 4.68l21.53-5.21V44.2l-21.53 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M52.53 10.63l1.44-.32v39.53l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M34.54 8.28L6.75 2.25v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-2"
            d="M6.29 1.52l28.75 6.23V59.3L6.29 52.25zm27.74 7.27L7.29 3v48.24l26.79 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M31.53 12.94L9.49 8.09v3.56l22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M9.29 7.71l22.55 5V17L9.29 11.92zm22 5.49L9.75 8.46v2.92l21.54 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M31.53 16.55l-22.04-4.9v3.57l22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M9.29 11.27l22.55 5v4.27L9.29 15.48zm22 5.54L9.75 12v3l21.54 4.76z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M31.53 20.16L9.49 15.22v3.58l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M9.29 14.84l22.55 5v4.28L9.29 19.05zm22 5.58L9.75 15.6v2.92l21.54 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M31.53 23.8L9.49 18.82v3.57l22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-2"
            d="M9.29 18.43l22.5 5.1v4.27l-22.5-5.15zm22 5.64L9.75 19.19v2.93L31.29 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M31.53 27.41L9.49 22.39v3.57l22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-2"
            d="M9.29 22l22.5 5.13v4.27l-22.5-5.18zm22 5.67l-21.54-4.9v2.92l21.54 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M31.53 31.02L9.49 25.96v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M9.29 25.57l22.5 5.18V35l-22.5-5.21zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M31.53 34.63L9.49 29.52v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M9.29 29.14l22.5 5.23v4.26l-22.5-5.28zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M31.53 38.24L9.49 33.09v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M9.29 32.71L31.79 38v4.27l-22.5-5.35zm22 5.8l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M31.53 41.86l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M9.29 36.28l22.5 5.31v4.27l-22.5-5.37zm22 5.84L9.75 37v3l21.54 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M31.53 45.49L9.49 40.25v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M9.29 39.87l22.5 5.36v4.27l-22.5-5.42zm22 5.89L9.75 40.63v2.92l21.54 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M31.53 49.11L9.49 43.82v3.57l22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-2"
            d="M9.29 43.43l22.5 5.41v4.27l-22.5-5.46zm22 5.94L9.75 44.2v2.92l21.54 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.53l1.44.35V10.63z"
        />
      </g>
      <path fill="#233762" d="M67.34 3.42h1.26v47.15h-1.26z" />
    </svg>
  );
};
